import { Localisation } from '../libs/Localisation';
import App from '../main';

export default class MainMenu extends Phaser.Scene {
    private mainMenuContainer: Phaser.GameObjects.Container;
    private languageContainer: Phaser.GameObjects.Container;
    constructor() {
        super({
            key: 'MainMenu'
        });
    }

    preload() {
        this.getStars();
        this.getMeta();
    }

    create() {
        // Reset game font text
        var resetText = this.add.text(0, 0, 'Hello!', {
            fontFamily: 'FredokaOne', fontSize: '81px', fontStyle: 'bold'
        })
        resetText.setVisible(false);

        if (!this.game.device.browser)
            document.getElementById("wrongRotation").style.display = "block";

        var reference = this.add.image(App.MAX_WIDTH_HALF, App.MAX_HEIGHT_HALF, 'bob')
        reference.visible = false;
        this.cameras.main.startFollow(reference);
        this.resize(this.scale.gameSize);
        App.AD_SHOWN = false;

        // create containers here
        this.mainMenuContainer = this.add.container(App.MAX_WIDTH_HALF, App.MAX_HEIGHT_HALF);
        this.languageContainer = this.add.container(App.MAX_WIDTH_HALF, App.MAX_HEIGHT_HALF);
        this.howToPlayContainer = this.add.container(App.MAX_WIDTH_HALF, App.MAX_HEIGHT_HALF);
        this.adPanelContainer = this.add.container(App.MAX_WIDTH_HALF, App.MAX_HEIGHT_HALF);
        this.adNotifyPanelContainer = this.add.container(App.MAX_WIDTH_HALF, App.MAX_HEIGHT_HALF);
        this.tournamentLoadingContainer = this.add.container(App.MAX_WIDTH_HALF, App.MAX_HEIGHT_HALF);
        this.tournamentHostContainer = this.add.container(App.MAX_WIDTH_HALF, App.MAX_HEIGHT_HALF);
        this.tournamentStartContainer = this.add.container(App.MAX_WIDTH_HALF, App.MAX_HEIGHT_HALF);
        this.tournamentListContainer = this.add.container(App.MAX_WIDTH_HALF, App.MAX_HEIGHT_HALF);

        this.cameras.main.setBackgroundColor('#EAE8FF');
        var gradient = this.add.sprite(0, App.MAX_HEIGHT_HALF * 0.8, 'BG_Gradients').setScale(0.75 * 4, 0.75 * 1.5).setTint(0xFFA1D6).setAlpha(0.7333333).setScrollFactor(1, 0);
        var pattern = this.add.tileSprite(-App.MAX_WIDTH_HALF, 75, App.MAX_WIDTH, App.MAX_HEIGHT, 'BG_Patterns_0').setScale(3).setAlpha(0.5529412).setScrollFactor(1, 0);
        this.tweens.add({
            targets: pattern,
            y: pattern.y - App.MAX_HEIGHT,
            duration: 20000 / 0.75,
            repeat: -1
        });

        this.mainMenuContainer.add(gradient);
        this.mainMenuContainer.add(pattern);
        if (!App.languageSet) {
            this.languageSelect();
        } else {
            this.mainMenuStart();
        }
        this.createAdPanel();
        this.createHowToPlayPanel();
        // this.createTournamentPanels();

        if (!App.BGM.isPlaying) {
            App.BGM.play({ loop: true });
        }

        if (App.SDK.isTournamentAfterGame) {
            this.openTournamentPanel();
        }
        else {
            this.mainMenuContainer.setVisible(true);
        }

        document.addEventListener("visibilitychange", () => {
            if (document.visibilityState === 'hidden') {
                this.sound.mute = true;
            }
            else if (document.visibilityState === 'visible') {
                if (!App.MUTE) {
                    this.sound.mute = false;
                }
            }
        });
    }

    languageSelect() {
        var startButton = this.add.image(0, 200., 'Ui', 'Ui_0').setScale(0.75 * 0.5);
        var playImage = this.add.image(10, 180, 'Ui', 'Ui_3').setScale(0.55);

        var rightButton = this.add.image(400, -240, 'NextButton');
        var leftButton = this.add.image(-400, -240, 'NextButton').setFlipX(true);
        var language = this.add.image(0, -240, 'english').setScale(2, 2);
        this.languageContainer.add(startButton);
        this.languageContainer.add(playImage);
        this.languageContainer.add(rightButton);
        this.languageContainer.add(leftButton);
        this.languageContainer.add(language);

        var index = 0;
        var leftIndex = 4;
        var rightIndex = 1;


        rightButton.setInteractive();
        rightButton.on('pointerup',  () => {
            this.sound.play('Click');

            index += 1;
            if (index >= 3)
                index = 0;
            App.langIndex = index;

            leftIndex = index - 1;
            rightIndex = index + 1;

            if (leftIndex >= 3)
                leftIndex = 0;
            else if (leftIndex < 0)
                leftIndex = 2;

            if (rightIndex >= 3)
                rightIndex = 0;
            else if (rightIndex < 0)
                rightIndex = 2;

            if (index == 0)
                language.setTexture('english');
            if (index == 1)
                language.setTexture('spanish');
            if (index == 2)
                language.setTexture('french');

        }, this);

        leftButton.setInteractive();
        leftButton.on('pointerup',  () => {
            this.sound.play('Click');

            index -= 1;
            if (index < 0)
                index = 2;
            App.langIndex = index;
            language.setTexture('english');

            leftIndex = index - 1;
            rightIndex = index + 1;

            if (leftIndex >= 3)
                leftIndex = 0;
            else if (leftIndex < 0)
                leftIndex = 2;

            if (rightIndex >= 3)
                rightIndex = 0;
            else if (rightIndex < 0)
                rightIndex = 2;

            if (index == 0)
                language.setTexture('english');
            if (index == 1)
                language.setTexture('spanish');
            if (index == 2)
                language.setTexture('french');
        }, this);

        startButton.setInteractive();
        startButton.once('pointerup',  () => {
            App.languageSet = true;
            this.languageContainer.setVisible(false)
            this.mainMenuStart();
        }, this);
    }

    mainMenuStart() {
        // var debugButton = this.add.image(0, -1080, 'Ui', 'Ui_0').setScale(0.75 * 0.25);
        // debugButton.setInteractive();
        // debugButton.on('pointerup', this.debugButton.bind(this), this);
        // this.mainMenuContainer.add(debugButton);

        var startButton = this.add.image(0, 570, 'Ui', 'Ui_0').setScale(0.75 * 0.5);
        var playImage = this.add.image(10, 550, 'Ui', 'Ui_3').setScale(0.55);
        // var fbInstantInviteButton = this.add.image(-400, 570, 'fbinstant_inviteButton').setScale(2);
        // var fbInstantTournamentButton = this.add.image(400, 570, 'fbinstant_tournamentButton').setScale(2);
        var someimage = this.add.image(0, -500, 'GameLogo').setScale(1);
        // var logo = this.add.image(0, 0.75 * 850, 'logo').setScale(0.6);

        // this.mainMenuContainer.add(fbInstantInviteButton);
        // this.mainMenuContainer.add(fbInstantTournamentButton);
        this.mainMenuContainer.add(startButton);
        this.mainMenuContainer.add(playImage);
        this.mainMenuContainer.add(someimage);
        // this.mainMenuContainer.add(logo);

        var platform = this.add.sprite(0, 40, 'Platform', 'Platform_0').setScale(0.75, 0.6);
        var mouth = this.add.sprite(0, 60, 'Platform', 'Platform_3').setScale(0.4);
        var eye1 = this.add.sprite(220, 50, 'Platform', 'Platform_2').setScale(0.35);
        var eye2 = this.add.sprite(-220, 50, 'Platform', 'Platform_2').setScale(0.35);
        var rightButton = this.add.image(440, -120, 'NextButton');
        var leftButton = this.add.image(-440, -120, 'NextButton').setFlipX(true);
        this.equipButton = this.add.sprite(0, 230, 'Ui_4', 'Ui_4_4').setScale(1, 0.75);
        this.equipButtonLabel = this.add.text(0, 225, Localisation.TEXTS.MENU_META_SELECTED_LABEL[App.langIndex], { fontFamily: 'FredokaOne', fontSize: '64px', fontStyle: 'bold', fill: '#712E3A' }).setOrigin(0.5, 0.5);
        this.equipButtonStar = this.add.sprite(-100, 225, 'PowerUps', 'PowerUps_2').setScale(0.4);
        this.equipButtonLock = this.add.image(-200, 166, 'lock-icon');
        var starsIcon = this.add.sprite(-440, -900, 'PowerUps', 'PowerUps_2').setScale(0.4);
        this.starsLabel = this.add.text(-360, -940, App.stars.toString(), { fontFamily: 'FredokaOne', fontSize: '72px', fontStyle: 'bold', fill: '#712E3A' });
        var character = this.add.sprite(0, -115, 'Character_1', 'Character_1_0').setScale(0.66);
        var char = this.add.sprite(100, -65, 'Character_1', 'Character_1_1').setScale(0.66);
        var leftCharacter = this.add.sprite(-250, -90, 'Characters_3', 'Characters_3_6').setScale(0.5).setAlpha(0.5);
        var leftChar = this.add.sprite(-175, -50, 'Characters_3', 'Characters_3_7').setScale(0.5).setAlpha(0.5);
        var rightCharacter = this.add.sprite(250, -90, 'Character_1', 'Character_1_6').setScale(0.5).setAlpha(0.5);
        var rightChar = this.add.sprite(327, -50, 'Character_1', 'Character_1_7').setScale(0.5).setAlpha(0.5);

        this.mainMenuContainer.add(character);
        this.mainMenuContainer.add(leftCharacter);
        this.mainMenuContainer.add(rightCharacter);
        this.mainMenuContainer.add(char);
        this.mainMenuContainer.add(leftChar);
        this.mainMenuContainer.add(rightChar);
        this.mainMenuContainer.add(rightButton);
        this.mainMenuContainer.add(leftButton);
        this.mainMenuContainer.add(platform);
        this.mainMenuContainer.add(eye1);
        this.mainMenuContainer.add(eye2);
        this.mainMenuContainer.add(mouth);
        this.mainMenuContainer.add(this.equipButton);
        this.mainMenuContainer.add(this.equipButtonLabel);
        this.mainMenuContainer.add(this.equipButtonStar);
        this.mainMenuContainer.add(this.equipButtonLock);
        this.mainMenuContainer.add(starsIcon);
        this.mainMenuContainer.add(this.starsLabel);

        // Character_1  --> _0  --> Default Blue
        // Character_1  --> _6  --> Game
        // Characters_3 --> _8  --> Popcorn
        // Characters_3 --> _3  --> Pumkin
        // Characters_2 --> _14 --> Avocado
        // Character_1  --> _2  --> Watermelon
        // Character_1  --> _8  --> Chicken
        // Characters_2 --> _9  --> Shark
        // Characters_3 --> _0  --> Monkey
        // Characters_3 --> _6 --> Fox
        App.characters[0] = ['Character_1', 'Character_1_0'];
        App.characters[1] = ['Character_1', 'Character_1_6'];
        App.characters[2] = ['Characters_3', 'Characters_3_8'];
        App.characters[3] = ['Characters_3', 'Characters_3_3'];
        App.characters[4] = ['Characters_2', 'Characters_2_14'];
        App.characters[5] = ['Character_1', 'Character_1_2'];
        App.characters[6] = ['Character_1', 'Character_1_8'];
        App.characters[7] = ['Characters_2', 'Characters_2_9'];
        App.characters[8] = ['Characters_3', 'Characters_3_0'];
        App.characters[9] = ['Characters_3', 'Characters_3_6'];
        var charArray = ['Character_1_1', 'Character_1_7', 'Characters_3_9', 'Characters_3_4', 'Characters_2_15', 'Character_1_3', 'Character_1_9', 'Characters_2_10', 'Characters_3_1', 'Characters_3_7'];

        var index = 0;
        var leftIndex = 4;
        var rightIndex = 1;

        App.SDK.setBase64Image(this.generateBase64('fbinstant_share'));

        var soundButton = this.add.image(440, -900, 'UI_New', this.game.sound.mute ? 'UI_New_5' : 'UI_New_6').setOrigin(0.5).setScale(0.6).setInteractive();
        this.mainMenuContainer.add(soundButton);
        soundButton.on('pointerdown', () => {
            // this.game.sound.mute = !this.game.sound.mute;
            // soundButton.setTexture('UI_New', this.game.sound.mute ? 'UI_New_5' : 'UI_New_6');
            if (App.MUTE) {
                App.MUTE = this.sound.mute = false;
                soundButton.setTexture('UI_New', 'UI_New_6');
                this.sound.play('Click');
            } else {
                App.MUTE = this.sound.mute = true;
                soundButton.setTexture('UI_New', 'UI_New_5');
            }
        });

        // var watchAdButton = this.add.image(380, 230, 'get-stars').setOrigin(0.5).setScale(2).setInteractive();
        // this.mainMenuContainer.add(watchAdButton);
        // watchAdButton.on('pointerup', function () {
        //     this.mainMenuContainer.setVisible(false);
        //     this.adPanelContainer.setVisible(true);
        // }, this);
        // watchAdButton.on('pointerup', this.watchAd.bind(this), this);

        var howToPlayButton = this.add.image(-400, 250, 'Ui', 'Ui_0').setOrigin(0.5).setScale(0.3, 0.28).setInteractive();
        this.mainMenuContainer.add(howToPlayButton);
        howToPlayButton.on('pointerdown', () => {
            this.sound.play('Click');
            this.mainMenuContainer.setVisible(false);
            this.howToPlayContainer.setVisible(true);
        });
        var howToPlayButtonIcon = this.add.text(-400, 240, "?", { fontFamily: 'FredokaOne', fontSize: '148px', fontStyle: 'bold', fill: '#712E3A' }).setOrigin(0.5, 0.5).setScale(0.75).setInteractive();
        this.mainMenuContainer.add(howToPlayButtonIcon);
        howToPlayButtonIcon.on('pointerdown', () => {
            this.sound.play('Click');
            this.mainMenuContainer.setVisible(false);
            this.howToPlayContainer.setVisible(true);
        });

        this.equipButton.setInteractive();
        this.equipButton.on('pointerup', this.setEquipButton.bind(this), this);

        rightButton.setInteractive();
        rightButton.on('pointerup',  () => {
            this.sound.play('Click');

            index += 1;
            if (index >= 10)
                index = 0;
            this.previewCharacterIndex = index;
            this.changeEquipButton(index);
            character.setTexture(App.characters[index][0], App.characters[index][1]);
            char.setTexture(App.characters[index][0], charArray[index]);

            leftIndex = index - 1;
            rightIndex = index + 1;

            if (leftIndex >= 10)
                leftIndex = 0;
            else if (leftIndex < 0)
                leftIndex = 9;

            if (rightIndex >= 10)
                rightIndex = 0;
            else if (rightIndex < 0)
                rightIndex = 9;

            leftCharacter.setTexture(App.characters[leftIndex][0], App.characters[leftIndex][1]);
            rightCharacter.setTexture(App.characters[rightIndex][0], App.characters[rightIndex][1]);
            leftChar.setTexture(App.characters[leftIndex][0], charArray[leftIndex]);
            rightChar.setTexture(App.characters[rightIndex][0], charArray[rightIndex]);

            if (index == 2)
                character.setY(-125);
            else if (index == 3)
                character.setY(-125);
            else if (index == 6)
                character.setY(-125);
            else if (index == 7)
                character.setY(-125);
            else
                character.setY(-115);

            if (leftIndex == 2)
                leftCharacter.setY(-100);
            else if (leftIndex == 3)
                leftCharacter.setY(-100);
            else if (leftIndex == 6)
                leftCharacter.setY(-100);
            else if (leftIndex == 7)
                leftCharacter.setY(-100);
            else
                leftCharacter.setY(-90);

            if (rightIndex == 2)
                rightCharacter.setY(-100);
            else if (rightIndex == 3)
                rightCharacter.setY(-100);
            else if (rightIndex == 6)
                rightCharacter.setY(-100);
            else if (rightIndex == 7)
                rightCharacter.setY(-100);
            else
                rightCharacter.setY(-90);
        }, this);

        leftButton.setInteractive();
        leftButton.on('pointerup',  () => {
            this.sound.play('Click');

            index -= 1;
            if (index < 0)
                index = 9;
            this.previewCharacterIndex = index;
            this.changeEquipButton(index);
            character.setTexture(App.characters[index][0], App.characters[index][1]);
            char.setTexture(App.characters[index][0], charArray[index]);

            leftIndex = index - 1;
            rightIndex = index + 1;

            if (leftIndex >= 10)
                leftIndex = 0;
            else if (leftIndex < 0)
                leftIndex = 9;

            if (rightIndex >= 10)
                rightIndex = 0;
            else if (rightIndex < 0)
                rightIndex = 9;

            leftCharacter.setTexture(App.characters[leftIndex][0], App.characters[leftIndex][1]);
            rightCharacter.setTexture(App.characters[rightIndex][0], App.characters[rightIndex][1]);
            leftChar.setTexture(App.characters[leftIndex][0], charArray[leftIndex]);
            rightChar.setTexture(App.characters[rightIndex][0], charArray[rightIndex]);

            if (index == 2)
                character.setY(-125);
            else if (index == 3)
                character.setY(-125);
            else if (index == 6)
                character.setY(-125);
            else if (index == 7)
                character.setY(-125);
            else
                character.setY(-115);

            if (leftIndex == 2)
                leftCharacter.setY(-100);
            else if (leftIndex == 3)
                leftCharacter.setY(-100);
            else if (leftIndex == 6)
                leftCharacter.setY(-100);
            else if (leftIndex == 7)
                leftCharacter.setY(-100);
            else
                leftCharacter.setY(-90);

            if (rightIndex == 2)
                rightCharacter.setY(-100);
            else if (rightIndex == 3)
                rightCharacter.setY(-100);
            else if (rightIndex == 6)
                rightCharacter.setY(-100);
            else if (rightIndex == 7)
                rightCharacter.setY(-100);
            else
                rightCharacter.setY(-90);
        }, this);

        this.tweens.add({
            targets: [startButton],
            scale: 0.75 * 0.6,
            duration: 1000,
            repeat: -1,
            yoyo: true
        });

        this.tweens.add({
            targets: [playImage],
            scale: 0.65,
            duration: 1000,
            repeat: -1,
            yoyo: true
        });

        // this.tweens.add({
        //     targets: [watchAdButton],
        //     scale: 1.5,
        //     duration: 1000,
        //     repeat: -1,
        //     yoyo: true
        // });

        startButton.setInteractive();
        startButton.once('pointerup', () => {
            // this.mainMenuContainer.setVisible(false);
            // this.adPanelContainer.setVisible(true);
            this.startGame();
        }, this);

        // fbInstantInviteButton.setInteractive();
        // fbInstantInviteButton.on('pointerup', function () {
        //     App.SDK.inviteFriend();
        // }, this);

        if (App.meta[0].status == 1) {
            this.equipButtonLabel.setText(Localisation.TEXTS.MENU_META_SELECTED_LABEL[App.langIndex]);
            this.equipButtonLabel.setAlpha(1);
            this.equipButton.setAlpha(1);
            this.equipButtonStar.setAlpha(0);
            this.equipButtonLock.setAlpha(0);
        }
        else {
            this.equipButtonLabel.setText(Localisation.TEXTS.MENU_META_EQUIP_LABEL[App.langIndex]);
            this.equipButtonLabel.setAlpha(1);
            this.equipButton.setAlpha(1);
            this.equipButtonStar.setAlpha(0);
            this.equipButtonLock.setAlpha(0);
        }

        // fbInstantTournamentButton.setInteractive();
        // fbInstantTournamentButton.on('pointerup', this.openTournamentPanel.bind(this), this);

        this.events.on('start',  () => {
            if (!App.BGM.isPlaying) {
                App.BGM.play({ loop: true });
            }
        }, this);

        this.mainMenuContainer.setVisible(false);
    }

    private resize(gameSize?: any) {
        this.cameras.main.width = gameSize.width;
        this.cameras.main.height = gameSize.height;
    }

    private startGame() {
        this.sound.play('Click');
        this.scene.start('NormalMode');
        this.scene.start('UI');

        if (!App.FIRST_TIME) {
            App.FIRST_TIME = true;
            App.SDK.onGameStart();
        } else {
            App.SDK.onGameRestart(this.registry.get('highScore'));
        }

        if (!App.TUTORIAL_SHOWN) {
            this.scene.launch('Tutorial');
        }
    }

    private adPanelContainer: Phaser.GameObjects.Container;
    private adNotifyPanelContainer: Phaser.GameObjects.Container;
    private adNotifyPanelLabel: any = null;
    private adNotifyPanelSprite: any = null;

    private createAdPanel() {
        // Ad Panel

        var background = this.add.sprite(0, App.MAX_HEIGHT_HALF * 0.8, 'BG_Gradients').setScale(0.75 * 4, 0.75 * 1.5).setTint(0xFFA1D6).setAlpha(0.7333333).setScrollFactor(1, 0);
        this.adPanelContainer.add(background);

        var label = this.add.text(0, -400, 'Watch Ad to get 75 stars.', { fontFamily: 'FredokaOne', fontSize: '72px', fontStyle: 'bold', fill: '#712E3A' }).setOrigin(0.5, 0.5);
        this.adPanelContainer.add(label);

        var watchAdButton = this.add.sprite(0, 0, 'Ui_4', 'Ui_4_0').setScale(1, 0.75);
        watchAdButton.setInteractive();
        watchAdButton.on('pointerup', this.watchAd.bind(this), this);
        this.adPanelContainer.add(watchAdButton);
        var watchAdButtonLabel = this.add.text(0, -5, "Watch Ad", { fontFamily: 'FredokaOne', fontSize: '64px', fontStyle: 'bold', fill: '#712E3A' }).setOrigin(0.5, 0.5);
        this.adPanelContainer.add(watchAdButtonLabel);

        var playButton = this.add.sprite(0, 250, 'Ui_4', 'Ui_4_4').setScale(1, 0.75);
        playButton.setInteractive();
        playButton.on('pointerup', this.closeAdPanel.bind(this), this);
        this.adPanelContainer.add(playButton);
        var playButtonLabel = this.add.text(0, 245, "Back", { fontFamily: 'FredokaOne', fontSize: '64px', fontStyle: 'bold', fill: '#712E3A' }).setOrigin(0.5, 0.5);
        this.adPanelContainer.add(playButtonLabel);

        this.adPanelContainer.setVisible(false);

        // Ad Error Panel

        var backgroundNotifyPanel = this.add.sprite(0, App.MAX_HEIGHT_HALF * 0.8, 'BG_Gradients').setScale(0.75 * 4, 0.75 * 1.5).setTint(0xFFA1D6).setAlpha(0.7333333).setScrollFactor(1, 0);
        this.adNotifyPanelContainer.add(backgroundNotifyPanel);

        this.adNotifyPanelLabel = this.add.text(0, -400, 'Checking for reward.', { fontFamily: 'FredokaOne', fontSize: '64px', fontStyle: 'bold', fill: '#712E3A' }).setOrigin(0.5, 0.5);
        this.adNotifyPanelContainer.add(this.adNotifyPanelLabel);
        this.adNotifyPanelSprite = this.add.image(0, 0, 'get-stars').setOrigin(0.5).setScale(2).setAlpha(1);
        this.adNotifyPanelContainer.add(this.adNotifyPanelSprite);

        this.adNotifyPanelContainer.setVisible(false);
    }

    private async watchAd() {
        this.sound.play('Click');
        this.game.sound.mute = true;
        // this.adPanelContainer.setVisible(false);
        this.adNotifyPanelContainer.setVisible(false);
        this.mainMenuContainer.setVisible(false);
        this.tournamentLoadingContainer.setVisible(true); // Loading from tournaments reused here.
        App.SDK.watchRewardAd('stars', (value: boolean) => {
            App.MUTE ? this.game.sound.mute = true : this.game.sound.mute = false;
            this.tournamentLoadingContainer.setVisible(false); // Loading from tournaments reused here.
            if (value) {
                this.setStars((App.stars + 75));                
                this.adNotifyPanelLabel.setText('You Got 75 Stars!');
                this.adNotifyPanelSprite.setAlpha(1);
                this.adNotifyPanelContainer.setVisible(true);
                this.sound.play('Star');
                this.time.delayedCall(3000, () => {
                    this.closeAdPanel();
                });
            }
            else {
                this.adNotifyPanelLabel.setText('Sorry, unable to give reward.');
                this.adNotifyPanelSprite.setAlpha(0.5);
                this.adNotifyPanelContainer.setVisible(true);
                this.time.delayedCall(3000, () => {
                    this.closeAdPanel();
                });
            }
        });
    }

    private closeAdPanel() {
        this.sound.play('Click');
        // this.adPanelContainer.setVisible(false);
        this.adNotifyPanelContainer.setVisible(false);
        this.mainMenuContainer.setVisible(true);
    }

    private howToPlayContainer: Phaser.GameObjects.Container;
    private howToPlayRightButton: any = null;
    private howToPlayLeftButton: any = null;
    private howToPlaySpriteNode: any = null;
    private howToPlaySprites: any = ['howtoplay1', 'howtoplay2', 'howtoplay3', 'howtoplay4'];
    private howToPlayLabelNode: any = null;
    private howToPlayLabels: any = ['Tap to drop the Doodle.', 'Collect Stars, Rubik\'s Cube\nand Power Ups.', 'Collect special Stars in\nRush Mode.', 'Use Stars to purchase Doodles.'];
    private howToPlayCurrentSlide: number = 0;
    private howToPlayLastSlide: number = 3;

    private createHowToPlayPanel() {
        var background = this.add.sprite(0, App.MAX_HEIGHT_HALF * 0.8, 'BG_Gradients').setScale(0.75 * 4, 0.75 * 1.5).setTint(0xFFA1D6).setAlpha(0.7333333).setScrollFactor(1, 0);
        this.howToPlayContainer.add(background);
        var exitButton = this.add.sprite(0, 700, 'Ui', 'Ui_0').setScale(0.75 * 0.5);
        exitButton.setInteractive();
        exitButton.on('pointerup', () => {
            this.sound.play('Click');
            this.howToPlayResetSlides();
            this.howToPlayContainer.setVisible(false);
            this.mainMenuContainer.setVisible(true);
        }, this);
        this.howToPlayContainer.add(exitButton);
        var exitImage = this.add.image(0, 690, 'closeButton').setScale(0.66).setOrigin(0.5);
        this.howToPlayContainer.add(exitImage);
        this.howToPlayRightButton = this.add.image(440, -300, 'NextButton').setInteractive();
        this.howToPlayContainer.add(this.howToPlayRightButton);
        this.howToPlayRightButton.on('pointerup', () => {
            this.sound.play('Click');
            this.howToPlayNextSlide();
        }, this);
        this.howToPlayLeftButton = this.add.image(-440, -300, 'NextButton').setFlipX(true).setInteractive();
        this.howToPlayContainer.add(this.howToPlayLeftButton);
        this.howToPlayLeftButton.on('pointerup', () => {
            this.sound.play('Click');
            this.howToPlayPreviousSlide();
        }, this);

        this.howToPlayLabelNode = this.add.text(0, 420, "How to play Doodle Drop?", { fontFamily: 'FredokaOne', fontSize: '64px', fontStyle: 'bold', fill: '#712E3A' }).setOrigin(0.5, 0.5);
        this.howToPlayContainer.add(this.howToPlayLabelNode);

        this.howToPlaySpriteNode = this.add.image(0, -300, 'closeButton').setScale(1).setOrigin(0.5);
        this.howToPlayContainer.add(this.howToPlaySpriteNode);

        this.howToPlayResetSlides();
        this.howToPlayContainer.setVisible(false);
    }

    private howToPlayResetSlides() {
        this.howToPlayCurrentSlide = 0;
        this.howToPlaySpriteNode.setTexture(this.howToPlaySprites[this.howToPlayCurrentSlide]);
        this.howToPlayLabelNode.setText(this.howToPlayLabels[this.howToPlayCurrentSlide]);
        this.howToPlayLeftButton.setVisible(false);
        this.howToPlayRightButton.setVisible(true);
    }

    private howToPlayNextSlide() {
        if (this.howToPlayCurrentSlide < this.howToPlayLastSlide) {
            this.howToPlayCurrentSlide++;
            this.howToPlaySpriteNode.setTexture(this.howToPlaySprites[this.howToPlayCurrentSlide]);
            this.howToPlayLabelNode.setText(this.howToPlayLabels[this.howToPlayCurrentSlide]);
            if (this.howToPlayCurrentSlide == this.howToPlayLastSlide) {
                this.howToPlayLeftButton.setVisible(true);
                this.howToPlayRightButton.setVisible(false);
            }
            else {
                this.howToPlayLeftButton.setVisible(true);
                this.howToPlayRightButton.setVisible(true);
            }
        }
    }

    private howToPlayPreviousSlide() {
        if (this.howToPlayCurrentSlide > 0) {
            this.howToPlayCurrentSlide--;
            this.howToPlaySpriteNode.setTexture(this.howToPlaySprites[this.howToPlayCurrentSlide]);
            this.howToPlayLabelNode.setText(this.howToPlayLabels[this.howToPlayCurrentSlide]);
            if (this.howToPlayCurrentSlide == 0) {
                this.howToPlayLeftButton.setVisible(false);
                this.howToPlayRightButton.setVisible(true);
            }
            else {
                this.howToPlayLeftButton.setVisible(true);
                this.howToPlayRightButton.setVisible(true);
            }
        }
    }

    // Meta Functions.

    private getMeta() {
        // App.meta = localStorage.getItem('hammerplay_doodledrop_meta');
        // if (App.meta == null || undefined) {
        //     App.meta = App.metaInitial;
        //     localStorage.setItem('hammerplay_doodledrop_meta', JSON.stringify(App.meta));
        //     App.meta = JSON.parse(localStorage.getItem('hammerplay_doodledrop_meta'));
        //     App.characterIndex = 0;
        // }
        // else {
        //     App.meta = JSON.parse(localStorage.getItem('hammerplay_doodledrop_meta'));
        for (let n = 0; n < App.metaLength; n++) {
            if (App.meta[n].status == 1) {
                App.characterIndex = n;
            }
        }
        // }
    }

    private setMeta(index: number, status: number) {
        App.meta[index].status = status;
        App.SDK.setDataMeta(App.meta);
        // localStorage.setItem('hammerplay_doodledrop_meta', JSON.stringify(App.meta));
    }

    private starsLabel: any = null;

    private getStars() {
        // App.stars = +localStorage.getItem('hammerplay_doodledrop_stars');
        // if (App.stars == 0 || null) {
        //     App.stars = 0;
        //     localStorage.setItem('hammerplay_doodledrop_stars', App.stars.toString());
        // }
        this.registry.set('stars', App.stars);
    }

    private setStars(starsToChange: number) {
        App.stars = starsToChange;
        App.SDK.setDataStars(App.stars);
        this.registry.set('stars', App.stars);
        // localStorage.setItem('hammerplay_doodledrop_stars', App.stars.toString());
        this.starsLabel.setText(App.stars.toString());
    }

    private previewCharacterIndex: number = 0;
    private maxCharactersIndex: number = 4; // Change according to the total number of Characters.
    private equipButton: any = null;
    private equipButtonStar: any = null;
    private equipButtonLock: any = null;
    private equipButtonLabel: any = null;

    private changeEquipButton(index: number) {
        if (App.meta[index].status == -1) {
            this.equipButton.setTexture('Ui_4', 'Ui_4_0');
            if (App.meta[index].cost <= App.stars) {
                this.equipButtonLabel.setText('     ' + App.meta[index].cost.toString());
                this.equipButton.setAlpha(1);
                this.equipButtonLabel.setAlpha(1);
                this.equipButtonStar.setAlpha(1);
                this.equipButtonLock.setAlpha(0);
            }
            else {
                this.equipButtonLabel.setText('     ' + App.meta[index].cost.toString());
                this.equipButton.setAlpha(0.5);
                this.equipButtonLabel.setAlpha(0.5);
                this.equipButtonStar.setAlpha(0.5);
                this.equipButtonLock.setAlpha(1);
            }
        }
        else {
            this.equipButton.setTexture('Ui_4', 'Ui_4_4');
            this.equipButton.setAlpha(1);
            if (App.meta[index].status == 1) {
                this.equipButtonLabel.setText(Localisation.TEXTS.MENU_META_SELECTED_LABEL[App.langIndex]);
                this.equipButtonLabel.setAlpha(1);
                this.equipButton.setAlpha(1);
                this.equipButtonStar.setAlpha(0);
                this.equipButtonLock.setAlpha(0);
            }
            else {
                this.equipButtonLabel.setText(Localisation.TEXTS.MENU_META_EQUIP_LABEL[App.langIndex]);
                this.equipButtonLabel.setAlpha(1);
                this.equipButtonStar.setAlpha(0);
                this.equipButtonLock.setAlpha(0);
            }
        }
    }

    private setEquipButton() {
        if (App.meta[this.previewCharacterIndex].status == 0) {
            this.sound.play('Click');
            for (let n = 0; n < App.characters.length; n++) {
                if (App.meta[n].status == 1) {
                    this.setMeta(n, 0);
                }
            }
            this.setMeta(this.previewCharacterIndex, 1);
            App.characterIndex = this.previewCharacterIndex;
        }
        else if (App.meta[this.previewCharacterIndex].status == -1) {
            if (App.meta[this.previewCharacterIndex].cost <= App.stars) {
                this.sound.play('Click');
                for (let n = 0; n < App.characters.length; n++) {
                    if (App.meta[n].status == 1) {
                        this.setMeta(n, 0);
                    }
                }
                this.setStars((App.stars - App.meta[this.previewCharacterIndex].cost));
                this.setMeta(this.previewCharacterIndex, 1);
                App.characterIndex = this.previewCharacterIndex;
            }
        }
        this.changeEquipButton(this.previewCharacterIndex);
    }

    // Facebook Functions.

    /** Method to generate Base64 string from texture. */
    private generateBase64(key: string, frame: string = null) {
        let base64 = this.textures.getBase64(key, frame, 'image/png', 0.92);
        return base64;
    }

    private tournamentLoadingContainer: Phaser.GameObjects.Container;
    private tournamentHostContainer: Phaser.GameObjects.Container;
    private tournamentStartContainer: Phaser.GameObjects.Container;
    private tournamentListContainer: Phaser.GameObjects.Container;

    private createTournamentLoadingPanel() {
        var background = this.add.sprite(0, App.MAX_HEIGHT_HALF * 0.8, 'BG_Gradients').setScale(0.75 * 4, 0.75 * 1.5).setTint(0xFFA1D6).setAlpha(0.7333333).setScrollFactor(1, 0);
        this.tournamentLoadingContainer.add(background);
        var label = this.add.text(0, 0, ' Loading... ', { fontFamily: 'FredokaOne', fontSize: '72px', fontStyle: 'italic', fill: '#712E3A' }).setOrigin(0.5, 0.5).setAlpha(0.75);
        this.tournamentLoadingContainer.add(label);

        this.tournamentLoadingContainer.setVisible(false);
    }

    private createTournamentHostPanel() {
        var background = this.add.sprite(0, App.MAX_HEIGHT_HALF * 0.8, 'BG_Gradients').setScale(0.75 * 4, 0.75 * 1.5).setTint(0xFFA1D6).setAlpha(0.7333333).setScrollFactor(1, 0);
        this.tournamentHostContainer.add(background);
        var exitButton = this.add.sprite(0, 700, 'Ui', 'Ui_0').setScale(0.75 * 0.5);
        exitButton.setInteractive();
        exitButton.on('pointerup', this.closeAllTournamentPanels.bind(this), this);
        this.tournamentHostContainer.add(exitButton);
        var exitImage = this.add.image(0, 690, 'closeButton').setScale(0.66).setOrigin(0.5);
        this.tournamentHostContainer.add(exitImage);

        var label = this.add.text(0, -480, "No Active Tournament.", { fontFamily: 'FredokaOne', fontSize: '64px', fontStyle: 'bold', fill: '#712E3A' }).setOrigin(0.5, 0.5);
        this.tournamentHostContainer.add(label);
        var createButton = this.add.sprite(0, 0, 'Ui_4', 'Ui_4_4').setScale(1, 0.75);
        createButton.setInteractive();
        createButton.on('pointerup', this.SDKCreateTournament.bind(this), this);
        this.tournamentHostContainer.add(createButton);
        var createButtonLabel = this.add.text(0, -5, "Create", { fontFamily: 'FredokaOne', fontSize: '64px', fontStyle: 'bold', fill: '#712E3A' }).setOrigin(0.5, 0.5);
        this.tournamentHostContainer.add(createButtonLabel);

        this.tournamentHostContainer.setVisible(false);
    }

    private createTournamentStartPanel() {
        var background = this.add.sprite(0, App.MAX_HEIGHT_HALF * 0.8, 'BG_Gradients').setScale(0.75 * 4, 0.75 * 1.5).setTint(0xFFA1D6).setAlpha(0.7333333).setScrollFactor(1, 0);
        this.tournamentStartContainer.add(background);
        var exitButton = this.add.sprite(0, 700, 'Ui', 'Ui_0').setScale(0.75 * 0.5);
        exitButton.setInteractive();
        exitButton.on('pointerup', this.closeAllTournamentPanels.bind(this), this);
        this.tournamentStartContainer.add(exitButton);
        var exitImage = this.add.image(0, 690, 'closeButton').setScale(0.66).setOrigin(0.5);
        this.tournamentStartContainer.add(exitImage);

        var label = this.add.text(0, -480, "Play a game to start tournament.", { fontFamily: 'FredokaOne', fontSize: '64px', fontStyle: 'bold', fill: '#712E3A' }).setOrigin(0.5, 0.5);
        this.tournamentStartContainer.add(label);
        var playButton = this.add.sprite(0, 0, 'Ui_4', 'Ui_4_0').setScale(1, 0.75);
        playButton.setInteractive();
        playButton.on('pointerup', this.SDKStartTournament.bind(this), this);
        this.tournamentStartContainer.add(playButton);
        var playButtonLabel = this.add.text(0, -5, "Play", { fontFamily: 'FredokaOne', fontSize: '64px', fontStyle: 'bold', fill: '#712E3A' }).setOrigin(0.5, 0.5);
        this.tournamentStartContainer.add(playButtonLabel);

        this.tournamentStartContainer.setVisible(false);
    }

    private tournamentListMaxElements: number = 5;
    private tournamentListYPositionDefault: number = -580;
    private tournamentListYPositionOffset: number = 240;
    private tournamentListYPosition: number = this.tournamentListYPositionDefault;
    private tournamentListPlayerRankLabel: any = null;
    private tournamentListPlayerEndLabel: any = null;
    private tournamentListPlayerPhotoSprite: any = null;
    private tournamentListPlayerNameLabel: any = null;
    private tournamentListPlayerScoreLabel: any = null;
    private tournamentListBanners: Array<any> = [];
    private tournamentListRankLabels: Array<any> = [];
    private tournamentListPhotoSprites: Array<any> = [];
    private tournamentListNameLabels: Array<any> = [];
    private tournamentListScoreLabels: Array<any> = [];

    private createTournamentListPanel() {
        var background = this.add.sprite(0, App.MAX_HEIGHT_HALF * 0.8, 'BG_Gradients').setScale(0.75 * 4, 0.75 * 1.5).setTint(0xFFA1D6).setAlpha(0.7333333).setScrollFactor(1, 0);
        this.tournamentListContainer.add(background);
        var exitButton = this.add.sprite(0, 700, 'Ui', 'Ui_0').setScale(0.75 * 0.5);
        exitButton.setInteractive();
        exitButton.on('pointerup', this.closeAllTournamentPanels.bind(this), this);
        this.tournamentListContainer.add(exitButton);
        var exitImage = this.add.image(0, 690, 'closeButton').setScale(0.66).setOrigin(0.5);
        this.tournamentListContainer.add(exitImage);

        this.tournamentListPlayerEndLabel = this.add.text(0, -760, 'Ends on', { fontFamily: 'FredokaOne', fontSize: '56px', fontStyle: 'italic', fill: '#712E3A' }).setOrigin(0.5, 0.5).setAlpha(0.75);
        this.tournamentListContainer.add(this.tournamentListPlayerEndLabel);

        for (let n = 0; n < this.tournamentListMaxElements; n++) {
            this.tournamentListBanners[n] = this.add.sprite(0, this.tournamentListYPosition + 10, 'fbinstant_tournamentListBanner').setScale(2.7, 2.5).setOrigin(0.5, 0.5).setAlpha(0);
            this.tournamentListContainer.add(this.tournamentListBanners[n]);
            this.tournamentListRankLabels[n] = this.add.text(-410, this.tournamentListYPosition, ' ' + (n + 1).toString() + ' ', { fontFamily: 'FredokaOne', fontSize: '60px', fontStyle: 'italic', fill: '#712E3A' }).setOrigin(0.5, 0.5);
            this.tournamentListContainer.add(this.tournamentListRankLabels[n]);
            this.tournamentListPhotoSprites[n] = this.add.image(-265, this.tournamentListYPosition, null).setDisplaySize(128, 128).setOrigin(0.5, 0.5);
            this.tournamentListContainer.add(this.tournamentListPhotoSprites[n]);
            this.tournamentListPhotoSprites[n].setAlpha(0);
            this.tournamentListNameLabels[n] = this.add.text(-170, this.tournamentListYPosition, 'Player ' + (n + 1).toString(), { fontFamily: 'FredokaOne', fontSize: '56px', fontStyle: 'bold', fill: '#712E3A' }).setOrigin(0, 0.5);
            this.tournamentListContainer.add(this.tournamentListNameLabels[n]);
            this.tournamentListScoreLabels[n] = this.add.text(425, this.tournamentListYPosition, '0', { fontFamily: 'FredokaOne', fontSize: '60px', fontStyle: 'bold', fill: '#712E3A' }).setOrigin(1, 0.5);
            this.tournamentListContainer.add(this.tournamentListScoreLabels[n]);
            this.tournamentListYPosition = this.tournamentListYPosition + this.tournamentListYPositionOffset;
        }

        var playerBanner = this.add.sprite(0, -960, 'fbinstant_tournamentPlayerBanner').setScale(2.7).setOrigin(0.5, 0.5);
        this.tournamentListContainer.add(playerBanner);
        this.tournamentListPlayerRankLabel = this.add.text(-410, -970, ' # ', { fontFamily: 'FredokaOne', fontSize: '60px', fontStyle: 'italic', fill: '#712E3A' }).setOrigin(0.5, 0.5);
        this.tournamentListContainer.add(this.tournamentListPlayerRankLabel);
        this.tournamentListPlayerPhotoSprite = this.add.image(-265, -970, null).setDisplaySize(128, 128).setOrigin(0.5, 0.5);
        this.tournamentListContainer.add(this.tournamentListPlayerPhotoSprite);
        this.tournamentListPlayerPhotoSprite.setAlpha(0);
        this.tournamentListPlayerNameLabel = this.add.text(-170, -970, 'Current Player', { fontFamily: 'FredokaOne', fontSize: '56px', fontStyle: 'bold', fill: '#712E3A' }).setOrigin(0, 0.5);
        this.tournamentListContainer.add(this.tournamentListPlayerNameLabel);
        this.tournamentListPlayerScoreLabel = this.add.text(425, -970, '0', { fontFamily: 'FredokaOne', fontSize: '60px', fontStyle: 'bold', fill: '#712E3A' }).setOrigin(1, 0.5);
        this.tournamentListContainer.add(this.tournamentListPlayerScoreLabel);

        this.tournamentListContainer.setVisible(false);
        this.tournamentListYPosition = this.tournamentListYPositionDefault;
    }

    // private getTournamentListPhotoSprites() {
    //     let self = this;
    //     let player: any = null;
    //     let playerID: Array<string> = [];

    //     if (App.FBInstant.activeTournament) {
    //         player = App.FBInstant.playerLeaderboardEntry;
    //         if (typeof player == 'undefined' || player == null) {
    //             this.tournamentListPlayerPhotoSprite.setTexture(null).setDisplaySize(128, 128).setAlpha(0);
    //         }
    //         else {
    //             if (this.textures.exists(`tournamentListPlayerPhotoSprite`) == true) {
    //                 this.tournamentListPlayerPhotoSprite.setTexture('tournamentListPlayerPhotoSprite').setDisplaySize(128, 128).setAlpha(1);
    //             }
    //             else {
    //                 this.load.image('tournamentListPlayerPhotoSprite', player.getPlayer().getPhoto());
    //                 this.load.once('filecomplete-image-tournamentListPlayerPhotoSprite', function () {
    //                     self.tournamentListPlayerPhotoSprite.setTexture('tournamentListPlayerPhotoSprite').setDisplaySize(128, 128).setAlpha(1);
    //                 }.bind(this), this);
    //                 this.load.start();
    //             }
    //         }

    //         for (let n = 0; n < this.tournamentListMaxElements; n++) {
    //             player = App.FBInstant.allLeaderboardEntries[n];
    //             if (typeof player == 'undefined' || player == null) {
    //                 this.tournamentListPhotoSprites[n].setTexture(null).setDisplaySize(128, 128).setAlpha(0);
    //             }
    //             else {
    //                 playerID[n] = player.getPlayer().getID();
    //                 if (this.textures.exists(`tournamentListPhotoSprite-${playerID[n]}`) == true) {
    //                     this.tournamentListPhotoSprites[n].setTexture(`tournamentListPhotoSprite-${playerID[n]}`).setDisplaySize(128, 128).setAlpha(1);
    //                 }
    //                 else {
    //                     this.load.image(`tournamentListPhotoSprite-${playerID[n]}`, player.getPlayer().getPhoto());
    //                     this.load.once(`filecomplete-image-tournamentListPhotoSprite-${playerID[n]}`, function () {
    //                         self.tournamentListPhotoSprites[n].setTexture(`tournamentListPhotoSprite-${playerID[n]}`).setDisplaySize(128, 128).setAlpha(1);
    //                     }.bind(this), this);
    //                     this.load.start();
    //                 }
    //             }
    //         }
    //     }
    // }

    // private getTournamentListData() {
    //     let player: any = null;

    //     if (App.FBInstant.activeTournament) {
    //         player = App.FBInstant.playerLeaderboardEntry;
    //         if (typeof player == 'undefined' || player == null) {
    //             this.tournamentListPlayerRankLabel.setText('');
    //             this.tournamentListPlayerNameLabel.setText('Play game to rank.');
    //             this.tournamentListPlayerScoreLabel.setText('');
    //             this.tournamentListPlayerPhotoSprite.setTexture(null).setDisplaySize(128, 128).setAlpha(0);
    //         }
    //         else {
    //             this.tournamentListPlayerRankLabel.setText(' ' + `${player.getRank()}` + ' ');
    //             this.tournamentListPlayerNameLabel.setText(`${player.getPlayer().getName()}`);
    //             this.tournamentListPlayerScoreLabel.setText(`${player.getScore()}`);
    //         }

    //         for (let n = 0; n < this.tournamentListMaxElements; n++) {
    //             player = App.FBInstant.allLeaderboardEntries[n];
    //             if (typeof player == 'undefined' || player == null) {
    //                 this.tournamentListBanners[n].setAlpha(0);
    //                 this.tournamentListRankLabels[n].setText('');
    //                 this.tournamentListNameLabels[n].setText('');
    //                 this.tournamentListScoreLabels[n].setText('');
    //             }
    //             else {
    //                 this.tournamentListBanners[n].setAlpha(1);
    //                 this.tournamentListRankLabels[n].setText(' ' + `${player.getRank()}` + ' ');
    //                 this.tournamentListNameLabels[n].setText(`${player.getPlayer().getName()}`);
    //                 this.tournamentListScoreLabels[n].setText(`${player.getScore()}`);
    //             }
    //         }

    //         this.getTournamentListPhotoSprites();

    //         let endDate = new Date(App.FBInstant.activeTournament.getEndTime() * 1000).toLocaleString();
    //         this.tournamentListPlayerEndLabel.setText('Ends on ' + endDate + ' ');
    //     }
    // }

    private createTournamentPanels() {
        this.createTournamentLoadingPanel();
        this.createTournamentHostPanel();
        this.createTournamentStartPanel();
        this.createTournamentListPanel();
    }

    private openTournamentPanel() {
        let self = this;
        this.sound.play('Click');
        this.tournamentStartContainer.setVisible(false); // Proxy Code. Remove Later.
        // if (FBInstantManager.isFBInstantEnabled) {
        //     this.mainMenuContainer.setVisible(false);
        //     this.tournamentStartContainer.setVisible(false);
        //     this.tournamentLoadingContainer.setVisible(true);
        //     if (App.FBInstant.activeTournament) {
        //         if (App.FBInstant.hasTournamentEnded == false) {
        //             App.SDK.sendScore(0);
        //             this.getTournamentListData();
        //         }
        //     }
        //     this.time.delayedCall(2500, function () {
        //         self.tournamentLoadingContainer.setVisible(false);
        //         if (App.FBInstant.activeTournament) {
        //             if (App.FBInstant.hasTournamentEnded == false) {
        //                 self.tournamentListContainer.setVisible(true);
        //             }
        //             else {
        //                 self.tournamentHostContainer.setVisible(true);
        //             }
        //         }
        //         else {
        //             self.tournamentHostContainer.setVisible(true);
        //         }
        //     });
        // }
    }

    private SDKCreateTournament() {
        let self = this;
        this.sound.play('Click');
        App.SDK.createTournament(0);
        this.tournamentHostContainer.setVisible(false);
        this.tournamentListContainer.setVisible(false);
        this.tournamentLoadingContainer.setVisible(true);
        this.time.delayedCall(5000,  () => {
            self.tournamentLoadingContainer.setVisible(false);
            self.tournamentStartContainer.setVisible(true);
        });
    }

    private SDKStartTournament() {
        this.sound.play('Click');
        this.scene.start('NormalMode');
        this.scene.start('UI');

        // if (!App.BGM.isPlaying) {
        //     App.BGM.play({ loop: true });
        // }
        if (!App.FIRST_TIME) {
            App.FIRST_TIME = true;
            App.SDK.onGameStart();
        } else {
            App.SDK.onGameRestart(this.registry.get('highScore'));
        }

        if (!App.TUTORIAL_SHOWN) {
            this.scene.launch('Tutorial');
        }
    }

    private closeAllTournamentPanels() {
        this.sound.play('Click');
        this.tournamentLoadingContainer.setVisible(false);
        this.tournamentHostContainer.setVisible(false);
        this.tournamentStartContainer.setVisible(false);
        this.tournamentListContainer.setVisible(false);
        this.mainMenuContainer.setVisible(true);
    }

    private debugButton() {
        App.SDK.setDataHighScore(10);
        App.SDK.setDataStars(5000);
        App.SDK.setDataMeta(App.metaInitial);
        console.log("Saved Game data reset. Restart the game to load the new Saved Game data.");
    }
}